module.exports = __webpack_public_path__ + "static/infinit-10170855c6f16d1ddc51611d3d3a7072.jpg";